import {environment} from '../../../../environments/environment';

export class Configuration {

  public readonly HEADER_FIELDS: any = {
    authCodeField: 'auth-code',
    dvxField: 'dvx-info',
    errorMessage: 'auth-message',
    remainingUserAttempt: 'auth-attempt',
    twoFaRequestCode: '2fa-request-code',
    twoFaTimeExpire: '2fa-time-expire',
    reCaptchaToken: 're-captcha-token'
  };

  public readonly IS_WIZARD: string = 'IS_WIZARD';
  public readonly TO_SAVE: string = 'TO_SAVE';
  public readonly LOCK_USER: string = 'LOCK_USER';
  public readonly LAST_PAGE: string = 'LAST_PAGE';
  public readonly VERSION: string = environment.appVersion;
  public readonly YEAR_COPY_RIGHT: number = ((new Date()).getFullYear());
  public readonly HTTP_RESOURCES: string = '/resources/';
  public readonly NUM_RETRY: number = 1;
  public readonly DEFAULT_LANGUAGE: string = 'it';
  public readonly SAVE_FOR_INACTIVITY: number = 600 * 1000; // 10 min
  public readonly SESSION_INACTIVITY: number = 7200 * 1000; // 2 hours
  public readonly WARNING_MESSAGE_SESSION_INACTIVITY: number = 60 * 1000; // 1 min
  public readonly WARNING_MESSAGE_SESSION_EXPIRED: number = 10 * 1000; // 10 sec
  public readonly WARNING_SESSION_INACTIVITY: number = this.SESSION_INACTIVITY - this.WARNING_MESSAGE_SESSION_INACTIVITY;
  public readonly MAX_FILE_SIZE_MB: number = 50;
  public MAINTENANCE = false;

  // Project properties
  public PROJECT_NAME = 'Hit-Fluencer';
  public DESCRIPTION = 'Le classifiche dei post dei social';
  public ROLES = {};

}
